import { xGetFromToIndex } from 'ml-spectra-processing/x';
import { xySortX } from 'ml-spectra-processing/xy';
import { xyArrayWeightedMerge } from 'ml-spectra-processing/xyArray';
export function merge(chromatogram, options = {}) {
    const { mergeThreshold = 0.3, seriesName = 'ms', range } = options;
    const times = chromatogram.getTimes();
    const series = chromatogram.getSeries2D(seriesName);
    if (range &&
        (range.from > chromatogram.lastTime || range.to < chromatogram.firstTime)) {
        return {
            x: [],
            y: [],
            from: { index: -1, time: 0 },
            to: { index: -1, time: 0 },
        };
    }
    const { fromIndex, toIndex } = xGetFromToIndex(times, range);
    const data = series
        .getData()
        .slice(fromIndex, toIndex + 1)
        .map((datum) => xySortX({ x: datum[0], y: datum[1] }));
    const { x, y } = xyArrayWeightedMerge(data, { delta: mergeThreshold });
    return {
        x,
        y,
        from: {
            index: fromIndex,
            time: times[fromIndex],
        },
        to: {
            index: toIndex,
            time: times[toIndex],
        },
    };
}
//# sourceMappingURL=merge.js.map